
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"1em","height":"1em","fill":"currentColor","viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M14 18a2 2 0 11-4 0 2 2 0 014 0zM13.6 12.184a7.016 7.016 0 00-6.556 1.873 1 1 0 101.416 1.412A4.981 4.981 0 0112 14c1.383 0 2.634.56 3.54 1.469a1 1 0 001.38.035l-3.32-3.32zM9.664 8.249a10.983 10.983 0 00-5.437 2.967 1 1 0 001.413 1.416 8.967 8.967 0 015.793-2.614l-1.769-1.77zM14.636 10.392a8.992 8.992 0 013.724 2.24 1 1 0 001.413-1.415 10.968 10.968 0 00-7.526-3.214l2.39 2.389zM6.469 5.053a15.019 15.019 0 00-5.077 3.341 1 1 0 101.415 1.414 12.995 12.995 0 015.225-3.192L6.47 5.053zM10.348 6.104A13.134 13.134 0 0112 6c3.59 0 6.84 1.454 9.193 3.808a1 1 0 001.415-1.414A14.956 14.956 0 0012 4c-1.16 0-2.29.132-3.374.381l1.722 1.723z"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M2.293 2.293a1 1 0 011.414 0l18 18a1 1 0 01-1.414 1.414l-18-18a1 1 0 010-1.414z"}})])
          )
        }
      }
    